module.exports = __webpack_public_path__ + "static/media/3.9b1b37fa.jpg";